import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/components-library';
import { format, parseISO } from 'date-fns';
import { useIntl } from 'react-intl';

import ActionButton, {
  ActionButtonSizes,
  ActionButtonVariants,
  ActionLink,
} from 'components/action-button';
import { FloatingLabelSelect } from 'components/floating-label-fields';
import { List } from 'components/list';
import { LOCALES } from 'state/intl/types';
import { routes } from 'utils/routing';

import { ArrowButton } from '../../../components/arrow-button';
import noop from '../../../utils/noop';
import { ContentWrap, SectionHeading } from '../support-form-v2.styled';

import { RecentOrdersDescriptionText } from './styled';
import { ISupportV2OrdersListViewProps } from './types';
import { localeStringToDateFnsLocale } from './utils';

const dateFormatForLocale = (locale: string) => (locale === LOCALES.fr_ca ? 'd MMMM' : 'MMMM d');

export const SupportV2OrdersListView: FC<ISupportV2OrdersListViewProps> = ({
  dropdownOptions,
  items,
  onYearAndMonthChange,
  selectedYearAndMonth,
  onSelectOrder = noop,
  onClickSignin = noop,
  isAuthenticated = false,
}) => {
  const { formatMessage, locale } = useIntl();

  return (
    <ContentWrap>
      <Box margin="2rem 0 1rem" width="100%" center>
        <ActionLink
          size={ActionButtonSizes.SMALL}
          to={routes.support}
          variant={ActionButtonVariants.OUTLINE}
        >
          {formatMessage({ id: 'backToTopics' })}
        </ActionLink>
      </Box>
      <SectionHeading data-testid="section-heading">
        {formatMessage({ id: 'recentOrders' })}
      </SectionHeading>
      <RecentOrdersDescriptionText>
        {formatMessage({ id: 'refundEligibilityInfo' })}
      </RecentOrdersDescriptionText>
      {isAuthenticated ? (
        <div>
          <FloatingLabelSelect
            label={formatMessage({ id: 'filterByMonth' })}
            value={selectedYearAndMonth}
            onChange={onYearAndMonthChange}
            options={dropdownOptions}
            data-testid="year-and-month-filter"
          />
          <List>
            {items.map(item => (
              <ArrowButton
                onClick={() => onSelectOrder(item)}
                key={item._id}
                data-testid="order-list-item-link"
              >
                <span>
                  <strong>
                    {format(parseISO(item.createdAt), dateFormatForLocale(locale), {
                      locale: localeStringToDateFnsLocale(locale),
                    })}
                  </strong>
                  <br />
                  {formatMessage({ id: 'xItems' }, { xItems: item.cart.cartEntries?.length })}
                </span>
              </ArrowButton>
            ))}
          </List>
        </div>
      ) : (
        <ActionButton onClick={onClickSignin} data-testid="sign-in-button">
          {formatMessage({ id: 'signInToViewOrders' })}
        </ActionButton>
      )}
    </ContentWrap>
  );
};
